import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGitlab, faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import './Home.css';
import Navbar from "../../util-components/NavBar";
import WorkExperience from '../work-experience/WorkExperience';
import Projects from "../personal-project/Projects";
import Contact from '../contact/Contact';
import Footer from "../footer/Footer";

const Home = () => {
  const [experience, setExperience] = useState('');

  useEffect(() => {
    // Calculate experience from March 2021 to now minus 4 months
    const startDate = new Date('2021-03-01');
    const currentDate = new Date();
    
    // Subtract 4 months from current date
    const adjustedDate = new Date(currentDate);
    adjustedDate.setMonth(adjustedDate.getMonth() - 4);
    
    // Calculate difference
    let years = adjustedDate.getFullYear() - startDate.getFullYear();
    let months = adjustedDate.getMonth() - startDate.getMonth();
    
    // Adjust for negative months
    if (months < 0) {
      years--;
      months += 12;
    }
    
    // Format the experience string
    let experienceText = '';
    if (years > 0) {
      experienceText += `${years} year${years > 1 ? 's' : ''}`;
    }
    if (months > 0) {
      if (experienceText) experienceText += ' ';
      experienceText += `${months} month${months > 1 ? 's' : ''}`;
    }
    
    setExperience(experienceText);
  }, []);

  return (
    <div className="container">
      <Navbar />
      
      <section className="profile-header" id="home">
        <div className="profile-container">
          <div className="profile-info">
            <h1>John Jordan Samaniego</h1>
            <h2>Software Engineer</h2>
            {experience && (
              <div className="experience-badge">
                {experience} of experience
              </div>
            )}
            <div className="profile-icons">
              <a href="https://gitlab.com/users/samaniego.johnjordan/groups" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faGitlab} />
              </a>
              <a href="https://github.com/jordge06" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faGithub} />
              </a>
              <a href="https://www.linkedin.com/in/john-jordan-samaniego-1712821b7/" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faLinkedin} />
              </a>
            </div>
          </div>
        </div>

        <div className="profile-desc">
          <p>
            Hi there, I'm a Software Engineer with {experience} of professional experience. 
            I've worked on both large monolithic codebases and smaller services throughout my career. 
            While primarily hired as a Backend Developer, I'm very flexible and can also work as a Frontend Developer. 
            My main language is Java, though I'm adaptable and comfortable working with whatever tech stack the company uses.
          </p>
        </div>
      </section>

      <section className="skills-section" id="skills">
        <h2>Core Competencies</h2>
        <div className="skills-grid">
          <div className="skill-card">
            <h3>Backend Development</h3>
            <div className="skill-tags">
              <span className="skill-tag">Java</span>
              <span className="skill-tag">Spring Boot</span>
              <span className="skill-tag">Spring Batch</span>
              <span className="skill-tag">Spring Actuator</span>
              <span className="skill-tag">Hibernate</span>
              <span className="skill-tag">Golang</span>
              <span className="skill-tag">REST APIs</span>
            </div>
          </div>
          
          <div className="skill-card">
            <h3>Frontend Development</h3>
            <div className="skill-tags">
              <span className="skill-tag">React JS</span>
              <span className="skill-tag">Angular JS</span>
              <span className="skill-tag">JavaScript</span>
              <span className="skill-tag">HTML/CSS</span>
            </div>
          </div>
          
          <div className="skill-card">
            <h3>DevOps</h3>
            <div className="skill-tags">
              <span className="skill-tag">Terraform</span>
              <span className="skill-tag">Control-M</span>
              <span className="skill-tag">Docker</span>
              <span className="skill-tag">Gitlab CI</span>
            </div>
          </div>

          <div className="skill-card">
            <h3>Cloud</h3>
            <div className="skill-tags">
              <span className="skill-tag">AWS Lambda</span>
              <span className="skill-tag">DynamoDB</span>
              <span className="skill-tag">API Gateway</span>
              <span className="skill-tag">Aurora DB</span>
              <span className="skill-tag">Secret Manager</span>
            </div>
          </div>
          
          <div className="skill-card">
            <h3>Database</h3>
            <div className="skill-tags">
              <span className="skill-tag">MySQL</span>
              <span className="skill-tag">PostGreSQL</span>
              <span className="skill-tag">DynamoDB</span>
              <span className="skill-tag">Sybase</span>
            </div>
          </div>

          <div className="skill-card">
            <h3>Tools</h3>
            <div className="skill-tags">
              <span className="skill-tag">IntelliJ</span>
              <span className="skill-tag">Eclipse</span>
              <span className="skill-tag">VS Code</span>
              <span className="skill-tag">Git</span>
              <span className="skill-tag">GitHub</span>
              <span className="skill-tag">Postman</span>
              <span className="skill-tag">Jira</span>
            </div>
          </div>
        </div>
      </section>

      <WorkExperience/>

      <Projects />

      <Contact />

      <Footer />
    </div>
  );
};

export default Home;